module.exports = __webpack_public_path__ + "ae714014e7edc9349c9e701a33176bc3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/membership/benefitBackground.png
// module id = 1795
// module chunks = 0